export default class ResultTypeMemberIdEnum {
  static get personalInfo() {
    return "D3F5473C-E6EF-ED11-907C-6045BD925644";
  }
  static get address() {
    return "6F2BB477-9AA1-4DDE-9AD6-35AB0F42DB93";
  }
  static get website() {
    return "3572E1F7-F553-EF11-AAE2-000C29E21A2A";
  }
  static get email() {
    return "2731C16A-0C94-4060-A711-5873238C3F33";
  }
  static get phone() {
    return "604722E0-16B3-4D8D-8294-47F51A87AE2C"
  }
  static get doctorSpeciality() {
    return "EC2EF5E3-B654-EF11-AAE2-000C29E21A2A"
  }
  static get doctorProfileSpeciality() {
    return "D79A41C0-A554-EF11-AAE2-000C29E21A2A"
  }
  static get awaitedCointainers() {
    return "B8EE8195-DADF-EE11-AAB8-000C29E21A2A";
  }
  static get realCointainers() {
    return "BFF8965A-BD03-EF11-AAB8-000C29E21A2A";
  }
  static get doctorSignature() {
    return "6C8D6681-0750-EF11-AAE2-000C29E21A2A";
  }
  static get lastName() {
    return "B2D75834-B4D8-4E45-9551-28D06C1A922D";
  }
  static get firstName() {
    return "FE3096E4-F717-468E-BDC6-47EC4E61BD69";
  }
  static get ICDCode() {
    return "66329C46-4991-EF11-AAF6-000C29E21A2A";
  }
  static get middleName() {
    return "364B69D7-2EF4-4378-A48E-B5BB89C43B08";
  }
  static get microscopyStatus() {
    return "9314D56B-2D03-EF11-AAB8-000C29E21A2A";
  }
  static get sex() {
    return 'F77C8568-91B8-4BDC-AF87-8468E2FA6FE6';
  }
  static get microscopyPhoto() {
    return "26E58E7E-35DA-EE11-AAB8-000C29E21A2A"
  }
  static get birthDay() {
    return "13B30714-56CC-4BCD-9B68-17FFCEF4B069"
  }
  static get deathDay() {
    return "227BEF5B-09B8-EF11-AAF9-000C29E21A2A"
  }
  static get pathohistologicalDiagnosis() {
    return "E0500CA3-552C-EE11-B8F0-6045BD92554D"
  }
  static get note() {
    return "1EB315AD-B8D4-EE11-AAB8-000C29E21A2A"
  }
  static get microDescription() {
    return "97B7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get stain() {
    return "1DB315AD-B8D4-EE11-AAB8-000C29E21A2A"
  }
  static get code() {
    return "ACB7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get aquisitionDay() {
    return "6B141191-C0D1-EE11-AAB8-000C29E21A2A"
  }
  static get medicalCardNumber() {
    return "526FB4F5-BFDB-EE11-AAB8-000C29E21A2A"
  }
  static get medicalFacility() {
    return "92B7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get IHCmcAB() {
    return "9C33FFB8-F2DB-EF11-AAFB-000C29E21A2A"
  }
  static get ISHprobes() {
    return "9495E0DD-F8DB-EF11-AAFB-000C29E21A2A"
  }
  static get department() {
    return "FD30DBEA-215A-EF11-AAE2-000C29E21A2A"
  }
  static get requestingPhysicianContacts() {
    return "B426CCCD-37DE-EE11-AAB8-000C29E21A2A"
  }
  static get attendingDoctor() {
    return "91B7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get macroDescription() {
    return "6C141191-C0D1-EE11-AAB8-000C29E21A2A"
  }
  static get microscopyComment() {
    return "1EB315AD-B8D4-EE11-AAB8-000C29E21A2A"
  }
  static get Immunohistochemical() {
    return "946FD72B-B454-EF11-AAE2-000C29E21A2A"
  }
  static get MolecularGenetic() {
    return "956FD72B-B454-EF11-AAE2-000C29E21A2A"
  }
  static get macroArchive() {
    return "9EB7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get materialType() {
    return "A7B7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get fixation() {
    return "A1B7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get decalcification() {
    return "A5B7AB2B-70D2-EE11-AAB8-000C29E21A2A"
  }
  static get researchType() {
    return "9B7C087F-DC53-EF11-AAE2-000C29E21A2A"
  }
  static get clinicalData() {
    return "D5500CA3-552C-EE11-B8F0-6045BD92554D"
  }
  static get clinicalDiagnosis() {
    return "D6500CA3-552C-EE11-B8F0-6045BD92554D"
  }
  static get reported() {
    return "4336B56F-73F2-EE11-AAB8-000C29E21A2A";
  }
  static get sent() {
    return "EFFCFEC5-13EC-EE11-AAB8-000C29E21A2A";
  }
  static get photo() {
    return "69B68A23-A0BE-4728-8AE3-F0CC29D59477"
  }
  static get issue() {
    return "116910F3-2BA0-EF11-AAF6-000C29E21A2A"
  }
}
